import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { Box, Grid, CircularProgress, Backdrop, Tooltip, Typography } from "@mui/material";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import {
  getDocumentPreSignedURL,
  uploadDocument,
} from "src/app-redux/work-order/actions/workorderActions";
import { IDocumentResponse } from "src/common/typings/s3-file-metadata";
import { delayWithTime } from "src/common/utils/app.util";
import AlertDialog from "src/components/AlertDialog/AlertDialog";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonButtonOutLined from "src/components/CommonButton/CommonButtonOutLined";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";
import NoRecordFound from "src/components/NoRecordFound";
import { Card } from "./Card";
import { useStyles } from "./styles";

const typeList = [
  { label: "Client Signoff", value: "Client Signoff" },
  { label: "General", value: "General" },
  { label: "Inspections", value: "Inspections" },
  { label: "Photos", value: "Photos" },
  { label: "Vendor Invoice", value: "Vendor Invoice" },
];
type Props = {
  expand: boolean;
};

export function VendorInvoice({ expand }: Props): React.ReactElement {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});
  const [docType, setDocType] = useState<string>("");
  const [docId, setDocId] = useState<string>("");
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState<boolean>(false);
  const [isConfirmDilog, setConfirmDilog] = useState<boolean>(false);
  const [isOpenDilog, setIsOpenDilog] = useState<boolean>(false);
  const [docInvoice, setDocInvoice] = useState<boolean>(false);
  const { ordNum } = useParams<{ ordNum: any }>();
  const [attachments, setAttachments] = React.useState<any>([]);
  const getNotesData = async () => {
    try {
      setLoader(true);
      setDocInvoice(false);
      const { unapprovedDocuments } = await fetchWrapper.get(`get-document-unapproved/${ordNum}`);

      if (unapprovedDocuments && unapprovedDocuments.length) {
        for (let i = 0; i < unapprovedDocuments.length; i++) {
          if (unapprovedDocuments[i].type === "Vendor Invoice") {
            setDocInvoice(true);
            break;
          }
        }
      }
      setInvoiceData(unapprovedDocuments);
      return setLoader(false);
    } catch (error: any) {
      setLoader(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };
  const handleAttachmentUpload = (event: any) => {
    const { files } = event.target;
    if (files) {
      setAttachments([...files]);
      setDocType("");
    }
  };
  const deleteFile = (fileName: string) => {
    const newFiles = attachments.filter((item: any) => item.name !== fileName);
    setAttachments(newFiles);
    setDocType("");
  };
  const addInvoice = async () => {
    setLoader(true);
    if (attachments?.length) {
      const docList: any[] = [];
      attachments.map((att: any) => {
        const fileNameExt = att?.name.split(".");
        const document: any = {
          FileName: att?.name,
          Type: docType,
          ContentType: att?.type,
          FileExtension: fileNameExt[fileNameExt.length - 1],
          OrdNum: parseInt(ordNum) || 0,
        };
        docList.push(document);
      });
      const asyncRes = await Promise.all(
        docList.map(async (dolis: any, i: number) => {
          await delayWithTime(5);
          const res: any = await dispatch(getDocumentPreSignedURL(dolis));
          let res2: any = {};
          if (res?.payload) {
            const payload = res.payload as IDocumentResponse;
            res2 = await dispatch(
              uploadDocument({
                url: payload.url,
                formData: attachments[i],
                contentType: dolis.ContentType,
                size: attachments[i].size,
                mgsNotShown: true,
              })
            );
          }
          return !(res?.error || res2?.error);
        })
      );
      if (asyncRes?.every((el) => el)) {
        getNotesData();
        setIsOpenDilog(false);
        dispatch(
          addNotificationAction({
            message: "Document Uploaded Successfully!",
            options: { variant: "success" },
          })
        );
      } else {
        dispatch(
          addNotificationAction({
            message: "Document Not Uploaded Successfully!",
            options: { variant: "error" },
          })
        );
      }
      setLoader(false);
    } else {
      dispatch(
        addNotificationAction({
          message: "Please select a file to upload",
          options: { variant: "error" },
        })
      );
      setLoader(false);
    }
  };
  const checkConfirmation = () => {
    const action = getbtnStatus();
    if (action) {
      setConfirmDilog(action);
    } else {
      addInvoice();
    }
  };
  const deleteDoc = async (id: string) => {
    setDocId(id);
    setIsConfirmDialogOpen(true);
  };
  const deleteDocuments = async () => {
    setLoader(true);
    try {
      setLoader(true);
      const res = await fetchWrapper.get(`delete-document-by-id/${parseInt(docId)}`);
      if (res.success) {
        dispatch(
          addNotificationAction({
            message: "Document deleted successfully!",
            options: { variant: "success" },
          })
        );
        getNotesData();
      } else {
        throw res.error;
      }
    } catch (error: any) {
      setLoader(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
    setIsConfirmDialogOpen(false);
    setLoader(false);
  };
  const getbtnStatus = () => {
    let status = false;
    if (attachments?.length && docType) {
      if (docType === "Vendor Invoice" && docInvoice) {
        status = true;
      } else {
        status = false;
      }
    } else {
      status = true;
    }
    return status;
  };
  React.useEffect(() => {
    if (expand) {
      getNotesData();
    }
  }, [expand]);
  const attachmentsLength = attachments.length;
  return (
    <>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container direction="row">
        <Grid xs={12} md={12}>
          <Box mt={2} />
          {Boolean(Object.keys(invoiceData).length) ? (
            Object.values(invoiceData).map((item, i) => (
              <Card key={i} index={i} RowData={item} deleteDoc={deleteDoc} />
            ))
          ) : (
            <>
              <NoRecordFound />
            </>
          )}
          <Grid item xs={12}>
            <Box component="span">
              <CommonButtonOutLined
                isGreen
                onClick={() => {
                  setIsOpenDilog(true);
                  setDocType("");
                  setAttachments([]);
                }}
              >
                Upload New Document
              </CommonButtonOutLined>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="row">
        <CommonDrawer
          heading={"Upload Document"}
          isOpen={isOpenDilog}
          closeDrawer={() => {
            setIsOpenDilog(false);
          }}
          drawerWidth={450}
        >
          <Box mt={3} />
          <Grid item xs={12} md={12}>
            <Box mr={1}>
              <CommonAutoCompleteField
                label="Type"
                name="type"
                optionsType={typeList}
                required
                disabled={attachmentsLength < 1}
                getOptionLabel={(option: any) => option.label || ""}
                getOptionDisabled={(option: any) =>
                  attachmentsLength > 1 ? option === typeList[2] || option === typeList[4] : []
                }
                value={typeList.find((ty: any) => ty.value === docType) || null}
                onChange={(option: any) => setDocType(option?.value || "")}
              />
            </Box>
          </Grid>
          <Grid xs={12} md={12} direction="row">
            <Box textAlign="right" mt={4} mr={1}>
              <CommonButton>
                {attachmentsLength
                  ? `${attachmentsLength} attachment(s) selected`
                  : "Upload Attachments"}
                <input
                  type="file"
                  accept=".xlsx, .pdf, .docx, .doc,.jpeg,.zip,.jpg,.png"
                  multiple
                  onChange={handleAttachmentUpload}
                  hidden
                />
              </CommonButton>
              <CommonButton
                isGreen
                disable={!attachmentsLength?.length && !docType}
                onClick={() => {
                  checkConfirmation();
                }}
              >
                Save
              </CommonButton>
            </Box>
          </Grid>
          {attachments && attachments.length > 0 && (
            <Box mt={3} mb={1}>
              <Typography variant="h6">Attached Files:</Typography>
              <Box mb={1} />
              <Grid container direction="row">
                {attachments.map((item: any) => {
                  return (
                    <>
                      <Grid item xs={11} md={11} key={`gridKey-${item.name}`}>
                        <Box mb={1} ml={2}>
                          <Typography
                            style={{
                              width: 350,
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              overflow: "hidden",
                            }}
                            key={item.name}
                          >
                            {item.name}
                          </Typography>{" "}
                        </Box>
                      </Grid>
                      <Grid item xs={1} md={1} key={`gridKey22-${item.name}`}>
                        <Tooltip title={"Delete File"} arrow placement="left-start">
                          <Box textAlign="right" mr={2}>
                            <Typography
                              onClick={() => deleteFile(item.name)}
                              style={{ cursor: "pointer" }}
                              key={`deletebtn${item.name}`}
                            >
                              x
                            </Typography>{" "}
                          </Box>
                        </Tooltip>
                      </Grid>
                    </>
                  );
                })}
              </Grid>
            </Box>
          )}
        </CommonDrawer>
      </Grid>
      <AlertDialog
        isOpen={isConfirmDialogOpen}
        handleClose={() => {
          setIsConfirmDialogOpen(false);
        }}
        message={"Are you sure you want to Delete this document?"}
        primaryButtonText="Ok"
        onPrimaryButtonClick={deleteDocuments}
        heading={"Delete Documents"}
      />
      <AlertDialog
        isOpen={isConfirmDilog}
        handleClose={() => {
          setConfirmDilog(false);
        }}
        noShowCancelBtn
        message={"You have already uploaded Vendor Invoice, remove previous one to upload new"}
        primaryButtonText="Ok"
        onPrimaryButtonClick={() => {
          setConfirmDilog(false);
        }}
        heading={"Warning"}
        headerColor="#eed202"
      />
    </>
  );
}
